<template>
  <div>
    <lottie
      :options="lottieOptions"
      :height="$rpxToPx(height)"
      :width="$rpxToPx(width)"
      class="lottie"
      @animCreated="handleAnimation"
    />
  </div>
</template>

<script>
import lottie from 'vue-lottie'

export default {
  name: 'ViaLottie',
  components: {
    lottie
  },
  props: {
    // rpx
    width: {
      type: Number,
      default: null
    },
    // rpx
    height: {
      type: Number,
      default: null
    },
    animationData: {
      type: Object,
      default: null
    },
    animationSpeed: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      anime: {}
    }
  },
  computed: {
    lottieOptions() {
      return {
        animationData: this.animationData
      }
    }
  },
  methods: {
    handleAnimation(anime) {
      this.anime = anime
      anime.setSpeed(this.animationSpeed)
    }
  }
}
</script>

<style scoped>

</style>
